import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import { NeokredNewLogo } from "../../../../utility/constants/assetsManager";
import {
  bgColor,
  colorWhite,
} from "../../../../utility/constants/colorManager";
import { STATUS_CODE_200 } from "../../../../utility/constants/valueConstants";
import { validateEmail } from "../../../../utility/emailValidator";
import ResizeListner from "../../../../utility/ResizeListner";
import { CustomButton } from "../../../components/main_comps/custom_button";
import { CustomInput } from "../../../components/main_comps/custom_input/CustomInput";
import ImageComponent from "../ImageComponent";

function ForgotPassword({ onClick, onSuccess }) {
  const { height, width } = ResizeListner();
  const { enqueueSnackbar } = useSnackbar();

  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [verified, setVerified] = useState("");

  useEffect(() => {
    if (email !== "" && validateEmail(email)) {
      setDisabled(false);
    } else setDisabled(true);
  }, [email]);

  const onClickForgotPassword = () => {
    setLoading(true);
    ApiRequestPost.forgotPasswordSendOtp({
      email,
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          onSuccess(email, response.data.otpRefCode, response.data.userId);
          enqueueSnackbar(response.message, {
            variant: "success",
          });
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
        setLoading(false);
      });
  };
  return (
    <div
      style={{
        width,
        display: "flex",
        flexDirection: width > 650 ? "row" : "column",
        height: height,
      }}
    >
      {/* <div
        style={{
          width: width > 650 ? "50%" : "100%",
          display: width > 650 ? "flex" : "none",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: colorWhite,
        }}
      >
        <img
          src={NeokredNewLogo}
          style={{
            width: width * 0.35,
            minWidth: 150,
            maxWidth: 400,
          }}
        />
      </div> */}
      <ImageComponent />
      <div
        style={{
          width: width > 650 ? "50%" : "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: bgColor,
          flexDirection: "column",
          height,
        }}
      >
        <div
          style={{
            width: width > 650 ? "45%" : "70%",
            minWidth: width > 650 ? 300 : 250,
          }}
        >
          <p
            style={{
              fontWeight: "600",
              fontSize: 27,
              marginBottom: 30,
              color: "#1A202C",
              margin: 0,
            }}
            className="roboto"
          >
            Forgot Password
          </p>
          <p
            style={{
              fontSize: 15,
              color: "#2D3748",
              margin: 0,
              marginBottom: 20,
              marginTop: 5,
            }}
            className="roboto"
          >
            Please enter the registered Email Address
          </p>
          <div style={{ marginTop: "25px" }}>
            <p
              style={{ margin: 0, color: "#4A5568", fontSize: "14px" }}
              className="roboto"
            >
              Email ID<span style={{ color: "#FC3629" }}>*</span>
            </p>
            <CustomInput
              type={"input"}
              title="Email"
              value={email}
              placeholder="John.Snow@gmail.com"
              onChange={setEmail}
              inputStyles={{
                width: "100%",
                border: "1px solid #E8E8E8",
                boxShadow: "none",
                backgroundColor: "white",
                height: "45px",
              }}
              validator="email"
              onPressEnter={() => {
                onClickForgotPassword();
              }}
            />
          </div>

          <CustomButton
            loading={loading}
            title="Continue"
            styles={{
              width: "100%",
              marginTop: 40,
              height: "50px",
              borderRadius: "4px",
            }}
            textStyle={{
              color: colorWhite,
              fontSize: 15,
              fontWeight: "500",
            }}
            onClick={() => {
              onClickForgotPassword();
            }}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
